import './App.css';
import MapComponent from './components/map'




function App() {

  return (
    <div className="App">

      <MapComponent/>
    </div>
  );
}

export default App;
